import { Injectable }  from '@angular/core';
import { forkJoin, of, Observable } from 'rxjs';
import { CommonService } from './common.service';
import { AuthService } from './auth.service';

@Injectable()
export class AppInitService {

    constructor(private commonService: CommonService, private authService: AuthService) {}

    init() {
        if (this.authService.isAuthenticated()) {
            this.authService.init();
            const obsArr: any = [];
            obsArr.push(this.commonService.fetchMiscConfig());
            obsArr.push(this.commonService.fetchWorkflowConfig());
            return new Observable((obs) => {
                forkJoin(obsArr).subscribe(() => {
                    obs.next(true);
                }, () => {
                    obs.next(true);
                }, () => {
                    obs.complete();
                });
            });
        }
        return of(true);
}
}
